<template>
  <div class="container">
    <div class="head">{{ $t('key1005161') }}</div>
    <div>
      <div class="operation">
        <div>
          <label>{{ $t('key1005162') }}</label>
          <Input v-model="searchValue" clearable :maxlength="500" @on-enter="search" :placeholder="$t('key1005160')" style="width: 200px"/>
          <Button class="ml10" @click="search">{{ $t('key1000108') }}</Button>
        </div>
        <!--<span  class="ml10">(可模糊搜索商户号、商户名、域名)</span>
        <Checkbox  class="ml10" @on-change="changeCheck" v-model="independent">仅独立部署</Checkbox>-->
        <span class="r-btn" @click="logout">{{ $t('key1000091') }}</span>
      </div>
    </div>
    <div class="list">
      <div v-for="item in list" class="item">
        <div class="title">{{ item.corporationName }}</div>
        <div class="buttons">
          <div class="btn" @click="gotoHandel(item)">{{ $t('key1005163') }}</div>
          <!--<div class="btn" @click="gotoHandel(item)">进入Listing</div>
          <div class="btn" @click="gotoHandel(item)">进入会员中心</div>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import {getToken, removeToken} from '@/utils/cookie';
import {errorUrlHandel, deleteTicket} from "@/utils/common";

export default {
  name: 'index',
  data() {
    return {
      searchValue: '',
      independent: false,
      list: []
    };
  },
  created() {

  },
  props: {},
  watch: {},
  methods: {
    logout() {
      let v = this;
      v.axios.get(api.get_logout + getToken('signOut')).then(response => {
        if (response.data.code === 0) {
          removeToken().then(() => {
            v.$store.commit('erpConfig', {});
            let url = deleteTicket(window.location.href);
            url = errorUrlHandel(url);
            window.location.href = response.data.others.logOutUrl + encodeURIComponent(url);
          });
        }
      });
    },
    search() {
      let v = this;
      v.axios.get(api.get_merchant_queryMerchantById + '?merchantId=' + v.searchValue).then(response => {
        if (response.data.code === 0) {
          v.list = [response.data.datas];
        }
      });
    },
    changeCheck(value) {
      this.search();
    },
    gotoHandel({merchantId, ymsListingDomain}) {
      let v = this;
      v.axios.post(api.get_shopping_settleInMerchant, {
        settleinMerchantId: merchantId,
        settleinPlatformType: '1'
      }).then(response => {
        if (response.data.code === 0) {
          v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005159'));
          let ticket = response.data.datas.ticket || '';
          ymsListingDomain = ymsListingDomain.includes('http') ? ymsListingDomain : 'https://' + ymsListingDomain;
          window.open(ymsListingDomain + '/j_security_check?ticket=' + ticket, '_blank');
        }
      });
    }
  }
};
</script>

<style scoped lang="less">
.container {
  background-color: #F5F5F5;
  padding: 0 50px;
  min-height: 100%;

  .head {

    line-height: 58px;
    border-bottom: 1px solid #c7c5c5;
    font-size: 36px;
    color: #00a0e9;
    text-align: center;
    margin-bottom: 10px;
  }

  .operation {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .r-btn {
      color: #00a0e9;
      cursor: pointer;

      &:hover {
        opacity: 0.9;
      }
    }
  }

  .list {
    margin-top: 25px;
    display: flex;
    flex-wrap: wrap;

    .item {
      width: 24.25%;
      background-color: #ffffff;
      border: 1px solid #ddd;
      margin-right: 1%;
      margin-bottom: 20px;

      .title {
        height: 34px;
        line-height: 34px;
        border-bottom: 1px solid #ddd;
        padding-left: 5px;
        font-weight: 600;
        white-space: nowrap;
      }

      .buttons {
        display: flex;
        line-height: 34px;
        justify-content: flex-end;

        .btn {
          width: 33.33333%;
          height: 34px;
          text-align: center;
          border-left: 1px solid #ddd;
          cursor: pointer;
          transition: 0.1s background-color ease-in;
        }

        .btn:hover {
          background-color: #f1f1f1;
        }
      }
    }

    .item:nth-child(4n) {
      margin-right: 0;
    }
  }
}

</style>
